import { useEffect, useState } from "react";
import { api } from "../services/api";

export function useDashboardReport(active, userId, initialPeriod = "today") {
  const [selection, setSelection] = useState({ period: initialPeriod });
  const [revision, setRevision] = useState(0);
  const [state, setState] = useState({ key: "", data: null, loading: true, error: "" });
  const key = JSON.stringify([userId, selection]);

  useEffect(() => {
    if (!active || !userId) return undefined;
    let disposed = false;
    let inFlight = false;
    let controller;
    const refresh = async () => {
      if (inFlight || document.hidden) return;
      inFlight = true;
      controller = new AbortController();
      setState((current) => ({ key, data: current.key === key ? current.data : null, loading: true, error: "" }));
      try {
        const data = await api.dashboardReport(selection, { signal: controller.signal });
        if (!disposed) setState({ key, data, loading: false, error: "" });
      } catch (error) {
        if (!disposed) setState((current) => ({ ...current, loading: false, error: error.message }));
      } finally {
        inFlight = false;
      }
    };
    refresh();
    const timer = window.setInterval(refresh, 30_000);
    document.addEventListener("visibilitychange", refresh);
    window.addEventListener("online", refresh);
    return () => {
      disposed = true;
      controller?.abort();
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", refresh);
      window.removeEventListener("online", refresh);
    };
  }, [active, userId, key, selection, revision]);

  return {
    ...state,
    data: state.key === key ? state.data : null,
    loading: state.key !== key || state.loading,
    error: state.key === key ? state.error : "",
    selection,
    select: setSelection,
    reload: () => setRevision((value) => value + 1),
  };
}
